// @flow

import React from 'react'
import styled from 'styled-components'

import { zIndexes } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'components/styles/_media'

const Container = styled.div`
  z-index: ${zIndexes.main};
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: rgba(100, 100, 100, 0.8);
  padding: 12px 24px 12px 5px;
  border-radius: 3px;
  color: #fff;
  line-height: 1.3;
  font-size: 13px;
  ${mediaMax.tablet`
  bottom: 8px;
    right: auto;
    width: 90%;
    width: calc(100% - 20px);
    margin: 0 10px;
    font-size: 12px;
    padding: 10px 24px 10px 5px;
  `};
`

const Icon = styled.i`
  margin-top: 2px;
`

const WeeklyGuests = styled.span`
  font-weight: bold;
  font-size: 16px;
  margin: 0 3px;
`

const PopupClose = styled.p`
  position: absolute;
  top: 50%;
  right: 7px;
  margin-top: -7px;
  a {
    padding: 3px;
    color: #4a4b4e;
    &:hover {
      opacity: 0.8;
    }
  }
`

type PropTypes = {
  guestsCount: number,
  onClickClose: Function,
}

export default (props: PropTypes) => (
  <Container>
    <ul className="fa-ul">
      <li>
        <Icon className="fa fa-lg fa-clock-o fa-li" />
        {i18n.t('page.room.weeklyGuestsPrefix')}
        <WeeklyGuests>{props.guestsCount}</WeeklyGuests>
        {i18n.t('page.room.weeklyGuestsSuffix')}
      </li>
    </ul>
    <PopupClose>
      <a href="#" onClick={e => props.onClickClose(e, props, 0)}>
        <i className="fa fa-times" />
      </a>
    </PopupClose>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/AttentionPopup/index.jsx